import { useAppStore } from "@/stores/app";
import { computed, onMounted, onUnmounted, ref } from "vue";

export const usePageBackground = () => {
  const store = useAppStore();

  const S3_BASE_URL = import.meta.env.VITE_APP_S3_PUBLIC_URL;
  const brand = store.brand;

  const keyboardOffset = ref(0);

  const updateKeyboardOffset = () => {
    if (!window.visualViewport) return;

    const viewportHeight = window.visualViewport.height;
    const windowHeight = window.innerHeight;
    keyboardOffset.value = Math.max(0, windowHeight - viewportHeight);
  };

  onMounted(() => {
    window.visualViewport?.addEventListener("resize", updateKeyboardOffset);
  });

  onUnmounted(() => {
    window.visualViewport?.removeEventListener("resize", updateKeyboardOffset);
  });

  const backgroundImageSrc = computed(() => {
    const bgImage = store.appTexts?.homeBackgroundImage as string | undefined;
    if (!bgImage) return undefined;
    return `${S3_BASE_URL}/${brand}/assets/${bgImage}`;
  });

  const hasBackgroundImage = computed(() => !!backgroundImageSrc.value);

  const backgroundColor = computed(
    () => (store.appTexts?.homeBackgroundColor as string) || "#000000",
  );

  const mainStyle = computed(() => {
    const bgImage = backgroundImageSrc.value;

    return {
      ...(bgImage && {
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }),
      backgroundColor: backgroundColor.value,
      minHeight: "100vh",
      paddingBottom: keyboardOffset.value ? `${keyboardOffset.value}px` : undefined,
    };
  });

  return {
    mainStyle,
    backgroundImageSrc,
    hasBackgroundImage,
    backgroundColor,
  };
};
